import { render, staticRenderFns } from "./MsotAdd.vue?vue&type=template&id=23d81e5c&scoped=true&"
import script from "./MsotAdd.vue?vue&type=script&lang=js&"
export * from "./MsotAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d81e5c",
  null
  
)

export default component.exports